var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-body"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }